import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import { QaAccess, QaPendingOrder } from "./types";

export function useQaPending() {
  const [canAccess, setCanAccess] = useState(false);
  const [orders, setOrders] = useState<QaPendingOrder[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const reload = useCallback(async () => {
    setLoading(true);
    setError(false);
    try {
      const { data: access } = await axios.get<QaAccess>("/api/ClosingChecklistQa/Access");
      setCanAccess(access.canAccess);
      if (access.canAccess) {
        const { data } = await axios.get<QaPendingOrder[]>("/api/ClosingChecklistQa/Pending");
        setOrders(data);
      } else setOrders([]);
    } catch {
      setError(true);
      setOrders([]);
    } finally {
      setLoading(false);
    }
  }, []);
  useEffect(() => {
    void reload();
    const onFocus = () => { void reload(); };
    window.addEventListener("focus", onFocus);
    return () => window.removeEventListener("focus", onFocus);
  }, [reload]);
  return { canAccess, orders, loading, error, reload };
}
